import { render, staticRenderFns } from "./MoleculeAnchor.vue?vue&type=template&id=5fc02c18&"
import script from "./MoleculeAnchor.vue?vue&type=script&lang=js&"
export * from "./MoleculeAnchor.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeAnchor.vue?vue&type=style&index=0&id=5fc02c18&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports